import { getResponseErrorCode } from '../../../../utils/get-response-error-code';
export var SetPersonalDetailsErrorCodeV1;
(function(SetPersonalDetailsErrorCodeV1) {
    SetPersonalDetailsErrorCodeV1[SetPersonalDetailsErrorCodeV1[/**
     * MemberPersonalDetails is required.
     */ "MemberPersonalDetailsRequired"] = 30000] = "MemberPersonalDetailsRequired";
    SetPersonalDetailsErrorCodeV1[SetPersonalDetailsErrorCodeV1[/**
     * Invalid interest id.
     */ "InvalidInterestId"] = 30001] = "InvalidInterestId";
    SetPersonalDetailsErrorCodeV1[SetPersonalDetailsErrorCodeV1[/**
     * Invalid interest contact method id.
     */ "InvalidContactMethodId"] = 30002] = "InvalidContactMethodId";
    SetPersonalDetailsErrorCodeV1[SetPersonalDetailsErrorCodeV1[/**
     * Invalid pickup site id.
     */ "InvalidPickupSiteId"] = 30003] = "InvalidPickupSiteId";
    SetPersonalDetailsErrorCodeV1[SetPersonalDetailsErrorCodeV1[/**
     * Invalid primary site id.
     */ "InvalidPrimarySiteId"] = 30004] = "InvalidPrimarySiteId";
    SetPersonalDetailsErrorCodeV1[SetPersonalDetailsErrorCodeV1[/**
     * Invalid preferred site id.
     */ "InvalidPreferredSiteId"] = 30005] = "InvalidPreferredSiteId";
    SetPersonalDetailsErrorCodeV1[SetPersonalDetailsErrorCodeV1[/**
     * Invalid preferred genre id.
     */ "InvalidPreferredGenreId"] = 30006] = "InvalidPreferredGenreId";
    SetPersonalDetailsErrorCodeV1[SetPersonalDetailsErrorCodeV1[/**
     * Invalid education level id.
     */ "InvalidEducationLevelId"] = 30007] = "InvalidEducationLevelId";
    SetPersonalDetailsErrorCodeV1[SetPersonalDetailsErrorCodeV1[/**
     * Invalid occupation id.
     */ "InvalidOccupationId"] = 30008] = "InvalidOccupationId";
})(SetPersonalDetailsErrorCodeV1 || (SetPersonalDetailsErrorCodeV1 = {}));
export class SetPersonalDetailsErrorV1 extends Error {
    constructor(errorCode){
        const error = `Failed to update member details. API error code ${errorCode}: ${SetPersonalDetailsErrorCodeV1[errorCode]}`;
        super(error);
        this.errorCode = errorCode;
    }
}
export async function getSetPersonalDetailsErrorV1(error) {
    const errorCode = await getResponseErrorCode(error);
    return errorCode && Object.values(SetPersonalDetailsErrorCodeV1).includes(errorCode) ? new SetPersonalDetailsErrorV1(errorCode) : error;
}

//# sourceMappingURL=set-personal-details-error.js.map